"use client";

import { usePathname } from "next/navigation";
import DataDisplayTabs_Layout2 from "./DataDisplayTabs/Layout2";
import { da } from "zod/v4/locales";
import DataDisplayTabs_Layout1 from "./DataDisplayTabs/Layout1";

interface Picture {
  data: {
    id: string;
    attributes: {
      url: string;
      name: string;
      alternativeText: string;
    };
  };
}

interface TabContent {
  id: number;
  heading: string;
  picture?: Picture;
}

interface Props {
  data: {
    title?: string;
    tabContent: TabContent[];
  };
}

export default function DataDisplayCards({ data }: Props) {
  const pathname = usePathname()
  const isDeliveryShippingInfo = pathname === "/delivery-shipping-information";

  return (
    <>
      {
        isDeliveryShippingInfo ? <DataDisplayTabs_Layout2 data={data} /> :
          <DataDisplayTabs_Layout1 data={data} />
      }
    </>
  );
}